export default __webpack_public_path__ + "static/media/basecourse.a3f78670.png";